export default {
  titles: {
    encoding: 'Codificare',
    inbound: 'Intrare',
    user_info: 'Informații utilizator',
    settings: 'Setări',
    reset_daily_items: 'Resetezi articolele zilnice?',
    last_parcels: 'Ultimele colete',
    select_item: 'Selectează articolul',
    select_workstation: 'Selectează stația de lucru',
    select_language: 'Selectează limba',
    support: 'Asistență',
    select_printer: 'Selectează imprimanta',
    shipment_to_confirm: 'Expediere de confirmat',
    sorting_details: 'Detalii sortare',
    inventories: 'Inventare',
    pin_modal: 'Introdu PIN-ul pentru a forța asocierea',
    shipments: 'Expedieri',
    report_problem: 'Raportează o problemă',
    parcels: 'Colete',
    //moncler
    outbound_bthp: 'Certificat Ieșire BTHP'
  },
  simple_parcel_list: {
    to_read: 'De citit',
    ok: 'Ok',
    force: 'Forțează',
    force_parcel: 'Forțează coletul {{code}}',
    force_parcel_desc: 'Introdu PIN-ul utilizatorului pentru a forța coletul',
    forced: 'Forțat',
    unexpected: 'Neașteptat',
    remove: 'Elimină',
    invalid_pin: 'PIN utilizator invalid',
    loading: 'Se încarcă lista de colete'
  },
  create_parcel_gate: {
    //moncler
    width: 'Lățime',
    height: 'Înălțime',
    depth: 'Adâncime',
    tare: 'Tară',
    description: 'Descriere'
  },
  fields: {
    current_location: 'Locație curentă',
    identified_item: 'Articol identificat',
    ignored_items: 'Articole ignorate',
    ignored_with_reason_items: 'Articole ignorate cu motiv',
    error_items: 'Articole cu eroare',
    warning_items: 'Articole cu avertisment',
    umg: 'Umg',
    custom_class: 'Clasă personalizată',
    product_code: 'Cod produs',
    as400username: 'Utilizator AS400',
    item_components: 'Componente',
    //valentino
    mission: 'Misiune',
    mission_type: 'Tip misiune',
    supplier: 'Furnizor',
    physical_storage: 'Depozitare fizică',
    season: 'Sezon',
    ddt: 'DDT',
    notification: 'Notificare',
    ddt_date: 'Data DDT',
    notification_date: 'Data notificării',
    product_category: 'Categorie produs',
    status: 'Stare',
    date: 'Data',
    creation_date: 'Data creării',
    sender: 'Expeditor',
    year: 'An',
    number: 'Număr',
    row: 'Rând',
    entity: 'Entitate',
    labels: 'Etichete'
  },
  misc: {
    select_an_option: 'Selectează o opțiune...',
    not_set: 'Nesetat',
    current_value: 'Valoare curentă',
    pleaseWait: 'Te rugăm să aștepți...',
    not_associated: 'Neasociat',
    replaced: 'Înlocuit',
    production_order_info: 'Informații comandă de producție',
    reel_info: 'Informații bobină',
    reel_code: 'Cod bobină',
    assigned_supplier: 'Furnizor alocat',
    type: 'Tip',
    identifier_info: 'Informații identificator',
    identifier_events: 'Evenimente identificator',
    or: 'sau',
    select_place: `Bună {{user}}, selectează amplasamentele de origine pentru a continua`,
    back: 'Înapoi',
    refresh: 'Reîmprospătează',
    reload: 'Reîncarcă',
    save: 'Salvează',
    confirm: 'Confirmă',
    confirm_auto: 'Confirmare automată',
    update_and_confirm: 'Actualizează și confirmă',
    update: 'Actualizează',
    no_carton_found: 'Niciun cartonaș găsit',
    confirm_continue: 'Confirmă și continuă',
    cancel: 'Anulează',
    close: 'Închide',
    user: 'Utilizator',
    workstation: 'Stație de lucru',
    username: 'Nume utilizator',
    name: 'Nume',
    password: 'Parolă',
    login: 'Autentificare',
    encoding: 'Codificare',
    code: 'Cod',
    ean_code: 'Cod EAN',
    certilogo: 'Certilogo',
    enter_the_necessary_fields: 'Completează câmpurile necesare pentru a începe operațiunea',
    associated_items: 'Articole asociate',
    associate: 'Asociază',
    associated: 'Asociat',
    verify: 'Verifică',
    verify_association: 'Verifică',
    reading: 'Citire',
    processing: 'Se procesează',
    association: 'Asociere',
    associations: 'Asocieri',
    waiting: 'În așteptare',
    writing: 'Scriere',
    writing_progress: 'Scriere în curs...',
    partial_confirm: 'Confirmare parțială',
    retry: 'Reîncearcă',
    writing_association: 'Scriere și asociere',
    confirmed: 'Confirmat',
    unable_to_write: `Imposibil de scris tagul epc : {{code}} pentru produsul: {{productCode}}`,
    unable_to_get_next_epc: `Imposibil de obținut următorul epc pentru: {{productCode}}`,
    unable_to_connect_to_workstation: 'Imposibil de conectat la stația de lucru',
    tag_info: 'Informații tag',
    inbound: 'Intrare',
    outbound: 'Ieșire',
    stop: 'Oprește',
    start: 'Pornește',
    pause: 'Pauză',
    clear: 'Golește',
    tag_encoded_today: 'Taguri codificate astăzi',
    transaction_date: 'Data tranzacției',
    select_transaction_date: 'Selectează data tranzacției',
    ready_to_receive: 'Gata de recepție',
    change_password: 'Schimbă parola',
    logout: 'Deconectare',
    are_you_sure_to_logout: 'Sigur vrei să te deconectezi?',
    settings: 'Setări',
    roles: 'Roluri',
    role: 'Rol',
    email: 'Email',
    place: 'Amplasament',
    items: 'Articole',
    description: 'Descriere',
    color: 'Culoare',
    size: 'Mărime',
    part: 'Parte',
    total_reads: 'TOTAL CITIRI',
    total_ok: 'TOTAL OK',
    save_to_list: 'Salvează în listă',
    destination: 'Destinație',
    origin: 'Origine',
    new_parcel: 'Colet nou',
    status: 'Stare',
    parcel: 'Colet',
    read_parcel: 'Citește coletul',
    parcels: 'Colete',
    shipment: 'Expediere',
    creation_date: 'Data creării',
    search: 'Caută',
    select_search: 'Caută...',
    detail: 'Detaliu',
    quantity: 'Cantitate ({{quantity}})',
    only_quantity: 'Cantitate',
    style: 'Stil',
    material: 'Material',
    shipment_code_auto: 'Cod expediere (auto)',
    parcel_code_auto: 'Cod colet (auto)',
    next: 'Următorul',
    parcels_to_receive: 'Colete de recepționat',
    confirm_parcel: 'Confirmă coletul',
    image_missing: 'IMAGINE LIPSĂ',
    image: 'Imagine',
    loading: 'Se încarcă...',
    unknown_product: 'Produs necunoscut',
    unknown_tag: 'Tag necunoscut',
    invalid_tag: 'Tag invalid',
    virgin_tag: 'Tag virgin',
    tag_not_associated: 'Tag neasociat',
    killed: 'Dezactivat definitiv',
    stock: 'Stoc',
    valid: 'Valid',
    unknown: 'Necunoscut',
    actions: 'Acțiuni',
    reprint: 'Reimprimă',
    product: 'Produs',
    product_items: 'Articole produs',
    identifiers: 'Identificatori',
    zone: 'Zonă',
    location: 'Locație',
    report_repair: 'Raportează reparația',
    reason: 'Motiv',
    request_code_change: 'Solicită schimbarea codului',
    enable_workstation_emulation: 'Activează emularea stației de lucru',
    enable_browser_print_emulation: 'Activează emularea Browser Print',
    filter: 'Filtru',
    language: 'Limbă',
    warning: 'Avertisment',
    success: 'Succes',
    info: 'Info',
    checklist: 'Listă de verificare',
    optional: 'Opțional',
    phone: 'Telefon',
    version: 'Versiune',
    printer: 'Imprimantă',
    new_shipment: 'Expediere nouă',
    upc: 'UPC',
    model_part_color_size: 'Model / Parte / Culoare / Mărime',
    confirm_shipment: 'Confirmă expedierea',
    receive: 'Recepționează',
    delete: 'Șterge',
    delete_association: 'Șterge',
    change: 'Schimbă',
    from: 'De la',
    to: 'Până la',
    ignored: 'Ignorat',
    skipped: 'Omis',
    ignored_with_reason: 'Ignorat cu motiv',
    yes: 'Da',
    no: 'Nu',
    model: 'Model',
    typology: 'Tip',
    no_result: 'Niciun rezultat',
    expected: 'Așteptat',
    expected_plural: 'Așteptate',
    read: 'Citit',
    missing: 'Lipsă',
    unexpected: 'Neașteptat',
    unexpected_parcel: 'Colet neașteptat',
    ignored_plural: 'Ignorate',
    serial: 'Serie',
    priority: 'Prioritate',
    group: 'Grup',
    required_quantity: 'Cant. necesară',
    sorted_quantity: 'Cant. sortată',
    missing_quantity: 'Cant. lipsă',
    barcode: 'Cod de bare',
    barcode_bc: 'Cod de bare BC',
    sorted_date: 'Data sortării',
    customer: 'Nume client',
    list: 'Listă',
    list_position: 'Poziție în listă',
    select_date: 'Selectează data',
    item_info: 'Informații articol',
    item_identifier_info: 'Informații identificator articol',
    item_identifier_events: 'Evenimente identificator articol',
    item_events: 'Evenimente articol',
    operation_type: 'Tip operațiune',
    operation_place: 'Amplasament operațiune',
    loading_data: 'Te rugăm să aștepți, datele se încarcă ...',
    empty_item_events: 'Niciun eveniment găsit',
    show_more: 'Arată mai multe',
    hide_more: 'Ascunde',
    production_order: 'Comandă de producție',
    production_order_detail: 'Detaliu comandă de producție',
    production_order_row: 'Rând comandă de producție',
    production_order_sku: 'SKU comandă de producție',
    kill_tag: 'Dezactivează definitiv tagul',
    replace_tag: 'Înlocuiește tagul',
    replace_tag_with: 'Înlocuiește tagul cu {{tag}}',
    item_po: 'Comandă părinte articol',
    item_order: 'Comandă articol',
    item_row: 'Rând articol',
    pack_code: 'Cod pachet',
    send_reads: 'Trimite citirile',
    items_add_inventory_success: 'Articole adăugate în inventar',
    new: 'Nou',
    confirm_mission: 'Confirmă misiunea',
    confirm_mission_text: 'Sigur vrei să confirmi misiunea?',
    parziali: 'Parțial',
    total_quantity: 'Cantitate totală',
    accepted_quantity: 'Cantitate acceptată',
    country_check: 'Control țară',
    showcase_check: 'Control vitrină',
    attention: 'Atenție',
    clear_items: 'Continuând se vor elimina toate citirile, vrei să continui?',
    add_partial: 'Atenție',
    add_partial_text: 'Ar putea fi necesară crearea unei misiuni de asigurare a calității',
    add_partial_already_text:
      'Ar putea fi necesară crearea unei misiuni de asigurare a calității. UMG deja procesat. Vrei să suprascrii articolele citite?',
    error_cq_mission: 'Atenție, creează o misiune pentru controlul calității',
    warning_zone_items: 'IN_ANOTHER_ZONE',
    internal_tag: 'Tag intern',
    external_tag: 'Tag extern',
    error_tag: 'Tag cu eroare',
    awaiting: 'În așteptare',
    error_logs: 'Jurnale de erori',
    event_logs: 'Jurnale de evenimente',
    box_closed: 'Cutie închisă',
    box_out: 'Cutie ieșită',
    unexpected_list: 'Listă articole neașteptate',
    pending_tags: 'Taguri în așteptare',
    selected_zone: 'Zonă selectată',
    pricing: 'Prețuri',
    send_to_sap: 'Trimite la SAP',
    write_tag: 'Scrie tagul',
    identifier_tag: 'Tag identificator',
    digit_identifier_tag: 'Introdu tagul de scris',
    target_epc: 'EPC țintă',
    retry_write_tag: 'A apărut o eroare de scriere. Vrei să încerci din nou scrierea tagului?',
    ready: 'Gata',
    offline: 'Offline',
    shipping_date: 'Data expedierii',
    update_only_product: 'Articolul este deja asociat altui produs. Sigur vrei să îl suprascrii?',
    update_production_order_row:
      'Articolul este deja asociat altui rând de comandă de producție. Sigur vrei să îl suprascrii?',
    export: 'Exportă',
    select_zone: 'Selectează zona',
    location_origin: 'Locația de origine',
    confirm_kill_tag: 'Ce taguri vrei să dezactivezi definitiv?',
    kill_in_progress: 'Dezactivare definitivă taguri în curs',
    confirm_replace_tag: 'Ce taguri vrei să înlocuiești?',
    replace_in_progress: 'Înlocuire taguri în curs',
    select_tag_to_kill: 'Selectează tagul de dezactivat definitiv',
    disassociating_item: 'Disasociere articol',
    killing_tag: 'Dezactivare definitivă tag {{type}} cu rolul {{role}}',
    retry_kill_tag:
      'A apărut o eroare la dezactivarea definitivă. Vrei să încerci din nou dezactivarea definitivă a tagului?',
    reading_tag: 'Citire tag',
    writing_tag: 'Scriere tag',
    writing_tag_with: 'Scriere tag {{tag}}',
    navBackWarning: 'Sigur vrei să te întorci? Toate modificările nesalvate, precum citirile, vor fi pierdute.',
    sentry: {
      report_problem: 'Descrie problema întâmpinată sau sugerează o îmbunătățire'
    },
    ready_to_read: 'Gata de citire',
    remove_product_readings: 'Elimină citirile produsului',
    ok: 'OK',
    already_in_parcel: 'deja în colet',
    operation_canceled_by_user: 'Operațiune anulată de utilizator',
    load_more: 'încărcare în curs',
    input: 'Intrare',
    rfid_barcodes: 'Coduri de bare RFID',
    submit: 'Trimite',
    //valentino
    error: 'Eroare',
    OK_WORKER: 'OK WORKER',
    KO_WORKER: 'KO WORKER',
    OK_REPAIR: 'OK REPARAȚIE',
    RESO_RICHIESTO_CQ: 'CC SOLICITAT',
    RESO_OK: 'OK RETUR',
    OK_VALDAGNO: 'OK VALDAGNO',
    KO_VALDAGNO: 'KO VALDAGNO',
    SECOND_VALDAGNO: 'ALEGERE A DOUA',
    OK_LINING: 'OK LINING',
    ok_first_inbound_status: 'OK PRIMA INTRARE',
    OK_RISC: 'RISC',
    KO_LINING: 'KO LINING',
    size_color: 'Mărime/Culoare',
    select_size_color: 'Selectează mărimea/culoarea',
    print: 'Tipărește',
    missings: 'Lipsă',
    embedded: 'Încorporate',
    ignoreds: 'Ignorate',
    select_printer: 'Selectează imprimanta',
    printing_started: 'Tipărire începută',
    release_reports: 'Rapoarte de lansare',
    quality_checks: 'Controale de calitate',
    quality_check: 'Control de calitate',
    total_mission_qty: 'Cant. totală misiune',
    inbound_read_qty: 'Cant. citită la intrarea în poartă',
    checked_qty: 'Cant. controale efectuate',
    checked: 'Testate',
    returned: 'Returnate',
    damaged: 'Defecte',
    qty_damaged_first_check: 'Cant. defecte la primul control',
    first_check_date: 'Data primului control',
    qty_damaged_second_check: 'Cant. defecte la al doilea control',
    second_check_date: 'Data celui de-al doilea control',
    note: 'Note',
    work_order: 'Comandă de lucru',
    order_type: 'Tip comandă',
    //louis vuitton
    start_and_read: 'Pornește antenele și poziționează produsul',
    emulate: 'Emulează',
    advanced_emulation: 'Emulare avansată',
    emulation_history: 'Istoric emulări',
    emulation_favorites: 'Favorite',
    power: 'Putere',
    sensitivity: 'Sensibilitate',
    expected_quantity: 'Așteptat',
    extra_quantity: 'Suplimentar',
    encoded_quantity: 'Codificat',
    clear_and_restart: 'Golește și repornește',
    all: 'Toate',
    today: 'Astăzi',
    lastweek: 'Săptămâna trecută',
    specific: 'Specific',
    apply: 'Aplică',
    products: 'Produse',
    last_paired_sn: 'Ultimul SN asociat',
    last_confirmed_ucs: 'Ultimul UCS confirmat',
    user_manual: 'Manual de utilizare',
    operation_user_manual: 'Manual de utilizare al operațiunii',
    activity: 'Activitate',
    encodings: 'Codificări',
    progress: 'Progres',
    encoding_user: 'Utilizator codificare',
    encoding_place: 'Amplasament codificare',
    total_encodings: 'Total codificări',
    sizes: 'Mărimi'
  },
  error: {
    error: 'Eroare',
    errors: 'Erori',
    forbidden: 'Interzis',
    not_found: 'Negăsit',
    product_not_found: 'Produs negăsit',
    unauthorized: 'Neautorizat',
    too_many_tags_read: 'Prea multe taguri citite (așteptate {{exptected}}, citite {{read}})',
    too_many_checklist_types:
      'Prea multe tipuri de listă de verificare. Selectează colete cu același tip de listă de verificare.',
    rfid_discrepancies_found:
      'Au fost găsite discrepanțe RFID, golește tot și încearcă din nou sau confirmă cu discrepanțe',
    certilogo_not_found: 'Certilogo "{{code}}" negăsit',
    ean_not_found: 'EAN "{{code}}" negăsit',
    production_order_not_found: 'Comanda de producție "{{code}}" negăsită',
    no_inbound_zones: 'Nicio zonă de intrare',
    no_operation_config: 'Configurația operațiunii nu a fost găsită',
    not_supported_reading_mode: 'Mod de citire neacceptat',
    undefined_operation_config: 'Configurația operațiunii nu poate fi nedefinită',
    certilogo_already_encoded: 'Certilogo "{{code}}" deja codificat',
    tag_not_found: 'Tag negăsit',
    missing_printer_id: 'IP imprimantă lipsă',
    tag_unassociated: 'Tag neasociat',
    tag_type_unexpected: 'Tip de tag neașteptat',
    tag_already_associated: 'Tag deja asociat. Trebuie mai întâi să îl disociezi',
    tags_not_associated: 'Unul sau mai multe taguri nu sunt asociate',
    tags_mismatch: 'Taguri necorespunzătoare',
    workstation_could_not_be_started: 'Stația de lucru {{code}} nu a putut fi pornită',
    antenna_was_started: 'Antena {{code}} a fost pornită',
    antenna_was_not_started: 'Antena {{code}} nu a fost pornită',
    authentication_failed: 'Autentificare eșuată',
    field_required: 'Câmpul {{label}} este obligatoriu',
    unable_to_connect_to_rfid_reader: 'Nu se poate conecta la cititorul RFID. Verifică dacă dispozitivul este pornit.',
    items_in_error_found: 'Au fost găsite articole cu erori',
    item_not_in_inbound: 'Articolul nu este în intrare',
    item_not_in_stock: 'Articolul nu este în stoc',
    item_in_another_parcel: 'Articol într-un alt colet',
    item_in_another_production_order: 'Articol într-o altă comandă de producție',
    connection: 'Eroare de conexiune',
    connection_details:
      'Nu a existat niciun răspuns de la server. Verifică dacă conexiunea la internet sau configurația VPN funcționează.',
    field_invalid_default: 'Valoare implicită nevalidă "{{defaultValue}}" pentru câmpul {{field}}',
    field_invalid: 'Valoare nevalidă pentru câmpul {{field}}',
    field_invalid_default_from_endpoint: 'Nu s-a găsit o valoare pentru câmpul {{field}}',
    sorting_already_read: 'Articolul cu serialul {{serial}} a fost deja citit în grupul {{group}}',
    sorting_no_group: 'Articol nesortabil',
    sorting_not_in_zone: 'Articolul cu serialul {{serial}} nu poate fi sortat. Deja în zona {{zone}}',
    sorting_unknown: 'Tagul {{tag}} nu este valid',
    sorting_unexpected: 'Tag neașteptat',
    no_item_configuration: 'Nicio configurație de articol găsită',
    item_creation_error: 'Eroare la crearea articolului',
    couldn_find_production_order: 'Comanda de producție nu a fost găsită',
    couldn_find_work_order: 'Comanda de lucru nu a fost găsită',
    couldn_find_production_order_row: 'Rândul comenzii de producție nu a fost găsit',
    missing_operation_option: 'Opțiune de operațiune lipsă: {{error}}',
    item_session_list_create: 'Listă necreată',
    item_session_list_create_session: 'Listă de sesiune necreată',
    item_session_list_confirm: 'Listă neconfirmată',
    item_session_list_confirm_session: 'Listă de sesiune neconfirmată',
    form_validation: 'Validare formular',
    form_validation_message: 'Eroare la completarea câmpului',
    select_place_error: 'Amplasamentul de origine nu a putut fi salvat',
    self_user_data: 'Datele tale nu au putut fi salvate',
    encoding_no_tags: 'Nu au mai fost citite alte taguri. Operațiune întreruptă',
    timeout_no_reads: 'Niciun tag/comandă de producție detectat. Apropie produsul de antenă și repornește',
    only_virgin_tag: 'Au fost detectate doar taguri virgine',
    tags_mismatch_error: 'Citește un singur tag pe rând',
    tags_mismatch_workorder: 'Rând de comandă de lucru necorespunzător',
    tags_errors: 'Erori taguri',
    value_not_valid: 'Valoarea introdusă nu este validă',
    write_tag: 'Eroare necunoscută la scrierea tagului',
    WRONG_PRODUCTION_ORDER: 'COMANDĂ DE PRODUCȚIE GREȘITĂ',
    WRONG_PLACE: 'AMPLASAMENT GREȘIT',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: 'Eroare la crearea rândului comenzii de producție',
    force_tag_associated: 'Tag deja asociat. Reasociezi?',
    operation_confirm_error: 'Eroare la confirmarea operațiunii',
    missing_mandatory_qc: 'Niciun control de calitate. Continuă?',
    wrong_qc_status: 'Produsul a fost declarat KO. Continuă?',
    wrong_qc_size: 'Verifică mărimea. Continuă?',
    wrong_qc_size_payload:
      'Verifică mărimea. Mărime codificare: {{productSize}} - Mărime fizică: {{manualSize}}. Continuă?',
    wrong_qc_model: 'Verifică modelul. Continuă?',
    start_checklist: 'Listă de verificare nepornită',
    confirm_with_unexpected: 'Nu se poate confirma cu taguri neașteptate',
    confirm_with_overqty: 'Nu se poate confirma cu taguri în exces',
    rfid_reader_initialization: 'Eroare necunoscută la inițializarea cititorului RFID',
    remove_sap_item_error: 'Articolul nu poate fi eliminat',
    no_asn_selected: 'Niciun ASN selectat',
    submit_asn: 'Eroare la trimiterea ASN',
    zbpNotFound: 'Agentul Zebra Browser Print nu a fost găsit în sistemul tău. Asigură-te că este instalat și pornit',
    no_printer_selected: 'Nicio imprimantă selectată',
    zplTemplateNotDefined:
      "Șablon ZPL nedefinit. Setează un cod de șablon în atributul 'zpl-template-code' al configurației operațiunii",
    no_print_template: 'Șablonul de tipărire nu a fost găsit',
    wrong_tag: 'Tag greșit',
    tag_authentication_error: 'Eroare de autentificare a tagului',
    authentication_timeout: 'Timp de autentificare expirat',
    tid_missing: 'TID lipsă pentru tagul citit',
    on_destination: 'la destinația {{destination}}',
    item_not_sortable: 'Articolul cu serialul {{serial}} nu este sortabil',
    search_error: 'Eroare de căutare',
    no_parcel_found_by_identifier: 'Niciun colet găsit cu acești identificatori',
    kill_tag_not_allowed:
      'Nu este posibil să dezactivezi definitiv un tag asociat unui articol. Pentru a dezactiva definitiv tagul, disociază mai întâi articolul.',
    kill_already_killed: 'Tag deja dezactivat definitiv',
    can_kill_only_tag_type: 'Poți dezactiva definitiv doar taguri {{type}}',
    replace_tag_not_allowed: 'Poți înlocui doar taguri asociate unui articol',
    kill_tag_not_success: 'Dezactivarea definitivă a tagului a eșuat',
    replace_tag_not_success: 'Înlocuirea tagului a eșuat',
    nfc_tag_not_expected: 'Tag NFC neașteptat pentru acest produs',
    ventilation_quantity_reached: 'Cantitatea de distribuit pentru acest produs a fost deja atinsă',
    confirm_not_allowed_with_errors: 'Confirmarea nu este permisă cu erori',
    close_not_allowed_with_errors: 'Închiderea nu este permisă cu erori',
    generic: 'A apărut o eroare la trimiterea feedbackului',
    form_entry: 'Unele câmpuri sunt obligatorii',
    invalid_tag_read: 'Citire de tag nevalidă',
    read_one_tag_time: 'Citește un singur tag pe rând',
    validation_failed_rewrite: 'Validarea a eșuat pentru configurația de rescriere',
    uhf_tag_not_found: 'Tag UHF negăsit',
    compute_tags_failed: 'Generarea tagului de scris a eșuat',
    be_generic_error: 'Eroare de sistem',
    be_generic_error_description: 'A apărut o eroare generică în sistem.',
    identifier_production_order_not_found: 'Comandă de producție negăsită',
    gs1code_invalid: 'Cod GS1 nevalid',
    productionorderrow_mismatch: 'Rând de comandă de producție necorespunzător. Continuă oricum?',
    //cucinelli
    nfc_already_associated: 'NFC deja asociat. Disociază-l și repetă operațiunea',
    too_many_valid_tag_read: 'Prea multe taguri valide citite',
    fields_required: ' este obligatoriu',
    exceeded_quantity: 'Cantitate depășită',
    production_order_completed: 'Comanda de producție este finalizată',
    work_order_completed: 'Comanda de lucru este finalizată',
    production_order_row_completed: 'Rândul comenzii de producție este finalizat',
    work_order_row_completed: 'Rândul comenzii de lucru este finalizat',
    replace_tag_not_allowed_for_this_tag: 'Nu este posibil să înlocuiești acest tip de tag',
    box_already_received: 'Cutie deja primită. Omite citirea.',
    MISSING_EAN_ATTRIBUTE: 'EAN negăsit pentru produsul {{productCode}}',
    other_production_order: 'Deja asociat unei alte comenzi de producție și unui alt produs',
    workorder_mismatch:
      'SKU-ul PRODUSULUI nu corespunde cu cel indicat pe ambalaj - Verifică dacă PRODUSUL de pe ambalaj este corect și continuă cu asocierea'
  },
  messages: {
    no_operations_found: 'Nicio operațiune găsită. Verifică permisiunile utilizatorului în ControlPanel',
    not_allowed_operation: `Nu ai permisiunea de a efectua această operațiune. Verifică configurația`,
    no_workstations_found: 'Nicio stație de lucru găsită',
    no_workstation_selected: 'Nicio stație de lucru selectată',
    are_you_sure_to_reset_daily_items: 'Sigur vrei să resetezi articolele zilnice?',
    bring_an_item_to_antenna: 'Apropie un articol de antenă',
    press_start_to_read: 'Apasă butonul Start pentru a \nporni citirea produselor RFID',
    reading_in_progress: 'Citire în curs',
    waiting_for_product: 'Se așteaptă produsul...',
    paste_comma_separeted_tags: 'Lipește tagurile separate prin virgulă, apoi apasă Enter...',
    connection_workstation_progress: 'Conectare la stația de lucru în curs..',
    operation_success: 'Operațiune confirmată cu succes',
    outbound_success: 'Ieșire confirmată cu succes',
    inbound_success: 'Intrare confirmată cu succes',
    pack_success: 'Ambalare confirmată cu succes',
    transfer_to_zone_success: 'Transfer în zonă confirmat cu succes',
    simple_item_list_success: 'Listă simplă de articole confirmată cu succes',
    list_empty: 'Lista este goală',
    looks_like_anything_in_list: 'Se pare că nu ai nimic în listă',
    generic_success: '{{code}} confirmat cu succes',
    generic_success_canceled: '{{code}} anulat cu succes',
    generic_error: 'Eroare {{code}}',
    fill_all_fields_and_search_an_item_configuration: 'Completează toate câmpurile și caută o configurație de articol',
    encoding_success: 'Codificare confirmată cu succes',
    encoding_success_none: 'Articol deja asociat anterior',
    read_some_identifier_to_start_verification: 'Citește un identificator pentru a începe verificarea',
    warning_items_found: 'Au fost găsite articole cu avertismente',
    are_you_sure_you_want_to_confirm: 'Sigur vrei să confirmi?',
    item_session_list_confirm: 'Listă confirmată cu succes',
    operation_in_progress: 'Operațiune în curs, te rugăm să aștepți...',
    sorting_error_zones: 'Zona de origine nu este valorizată, imposibil de continuat cu distribuirea',
    connection_in_progress: 'Conectare în curs...',
    checklist_there_are: 'Există',
    checklist_missings: 'articole lipsă',
    checklist_overqty: 'articole în exces',
    checklist_unexpecteds: 'articole neașteptate',
    checklist_confirm_mismatch_question: 'Sigur vrei să confirmi oricum?',
    force_update_content: 'Sigur vrei să forțezi trimiterea către SAP?',
    connection_to_station_in_progress: 'Conectare la stație în curs',
    tag_killed: 'Tag dezactivat definitiv',
    tag_replaced: 'Tag înlocuit',
    tag_deleted: 'Tag șters',
    write_tag: 'Tag scris cu succes',
    not_ready: 'Nepregătit',
    readyf: 'Pregătită',
    nfcDecryption: 'Decriptare NFC. Ține tagul nemișcat',
    parcel_success: 'Colet confirmat cu succes',
    sentry: {
      success: 'Îți mulțumim pentru feedback! Contribuția ta ne ajută să îmbunătățim serviciul.'
    },
    confirm_force_shipment: 'Confirmă expedierea cu PFAS',
    input_rfid_barcodes: 'Introdu codurile de bare RFID, separate prin virgulă sau rând nou',
    //valentino
    are_you_sure_to_clear_reads: 'Sigur vrei să golești citirile?',
    are_you_sure_to_confirm: 'Sigur vrei să confirmi?',
    inbound_conveyor_confirm_missing_message: 'Mai sunt articole -lipsă- de confirmat, sigur vrei să confirmi?',
    ///
    newVersionAvailable: 'Versiune nouă disponibilă',
    pageWillReload: 'Pagina se va reîncărca automat în 30 de secunde',
    update_available_description:
      'Este disponibilă o actualizare pentru această pagină. Reîncarcă pagina pentru a aplica actualizarea.',
    deviceManagerUpdateTitle: 'Actualizare Device Manager',
    deviceManagerUpdateDescription:
      'Este disponibilă o nouă actualizare Device Manager. Instaleaz-o acum pentru a asigura performanțe optime ale cititorului RFID.',
    deviceManagerUpdating: 'Device Manager se actualizează. Te rugăm să aștepți, poate dura până la 5 minute.',
    deviceManagerUpdateCompleted: 'Actualizare finalizată cu succes',
    deviceManagerUpdateCompletedAndRequiresReboot:
      'Actualizare finalizată cu succes. Repornește PC-ul pentru a aplica modificările.',
    exceeded_quantity_message:
      'Cantitatea pentru rândul comenzii de producție a fost atinsă. Schimbă rândul sau comanda de producție.',
    empty_production_order: 'Niciun rând prezent în comanda de producție',
    empty_production_order_search: 'Niciun rând al comenzii de producție nu corespunde căutării efectuate',
    areYouSureYouWantToDelete: 'Sigur vrei să ștergi?'
  },
  placeholder: {
    search_shipment_parcel: 'Caută expediere sau colet',
    search_product_parcel: 'Caută produs sau colet'
  },
  confirm: {
    discrepancy_title: 'Colet cu discrepanțe',
    discrepancy_message: 'Au fost găsite produse cu discrepanțe. Sigur vrei să confirmi coletul?',
    confirm_delete_association: 'Sigur vrei să ștergi această asociere de articol?',
    confirm_delete_operation_title: 'Șterge {{operation}}',
    confirm_delete_operation: 'Vrei să ștergi operațiunea? Toate articolele citite vor fi pierdute.',
    confirm_delete_item_association: 'Sigur vrei să ștergi această asociere de articol?',
    confirm_kill_tag: 'Sigur vrei să dezactivezi definitiv tagul {{type}} {{tag}}?',
    confirm_multiple_kill_tag: 'Sigur vrei să dezactivezi definitiv toate tagurile?',
    confirm_disassociate_kill_tag: 'Sigur vrei să disociezi și să dezactivezi definitiv tagul {{type}} {{tag}}?',
    confirm_disassociate_multiple_kill_tag: 'Sigur vrei să disociezi și să dezactivezi definitiv toate tagurile?',
    confirm_operation_title: 'Confirmă {{operation}}',
    confirm_operation_text: 'Vrei să confirmi operațiunea?',
    confirm_operation_text_irreversible: 'Vrei să confirmi operațiunea? Această acțiune nu poate fi anulată.',
    confirm_operation_text_partial_confirm: 'Se trimite citirea către JDE. Sigur vrei să continui?',
    confirm_operation_text_partial_confirm_without_jde: 'Sigur vrei să continui?',
    post_confirm_action_title: 'Continuă',
    post_confirm_action_keep_input: 'Operațiune finalizată. Efectuezi o altă operațiune?',
    post_confirm_action_change_input: 'Operațiune finalizată. Efectuezi o altă operațiune?',
    confirm_close_asn_title: 'Confirmare închidere',
    confirm_close_asn_text: 'Unele colete nu au fost recepționate. Sigur vrei să FORȚEZI închiderea acestei expedieri?',
    unpack: 'Coletul este deja ambalat. Vrei să continui cu dezambalarea și cu o nouă ambalare?',
    last_parcel_confirmerd: 'Toate coletele expedierii {{code}} au fost confirmate. Închizi și expedierea?'
  },
  labels: {
    draft: 'Ciornă',
    ready_to_send: 'Gata de trimitere',
    send_await: 'În așteptare',
    outbound_error: 'Eroare la ieșire',
    sent: 'Trimis',
    in_inbound: 'În intrare',
    receive_await: 'În așteptare',
    ready_to_receive: 'De recepționat',
    inbound_error: 'Eroare la intrare',
    received: 'Recepționat',
    in_transit: 'În tranzit'
  },
  serverError: {
    WRONG_ITEM_SUPPLIER: 'Unele articole citite nu pot fi preluate de furnizor.',
    QUANTITY_MISMATCH_ERROR: 'Cantitățile introduse nu corespund cu cantitățile detectate.',
    ZONE_MISMATCH_ERROR: 'Zona introdusă nu corespunde cu zona detectată.'
  },
  error_messages: {
    password_required: 'Câmpul parolă este obligatoriu',
    invalid_password: 'Parolă invalidă',
    missing_workstation_place: 'Amplasamentul stației de lucru lipsește',
    connection_in_progress_title: 'Ne pare rău, conexiunea a eșuat',
    connection_in_progress_text: 'Încearcă din nou mai târziu'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'DDT N.',
    creation_date: 'Data',
    capi_mdc: 'Capi MDC',
    qt_totale: 'Cant. totală',
    qt_accettata: 'Cant. acceptată',
    qt_scartata: 'Cant. respinsă',
    supplier: 'Furnizor',
    notes: 'Note'
  },
  custom: {
    countTBoxParcel: 'Colet',
    countTBoxDDT: 'DDT',
    BARCODE_READ: 'Cod de bare citit',
    RFID_START_READING: 'Pornește citirea',
    RFID_STOP_READING: 'Oprește citirea',
    RESULT_EVENT: 'Eveniment rezultat',
    TRACE: 'Urmărire',
    INFO: 'Info',
    WARNING: 'Avertisment',
    ERROR: 'Eroare',
    deleteSession: 'Șterge coletul',
    deleteSessionMessage: 'Sigur vrei să ștergi coletul?',
    deleteList: 'Șterge DDT',
    deleteListMessage: 'Sigur vrei să ștergi DDT-ul?',
    WAM: 'SKU',
    sap_warning: 'Avertisment SAP',
    total_list: 'Total listă',
    total_parcel: 'Total colet',
    order_number: 'Număr comandă',
    addon: 'Addon',
    componentType: 'Tip componentă',
    //cucinelli
    barcode: 'Cod de bare BC',
    barcodeBCTrim: 'Cod de bare BC trim',
    barcodeJDE: 'Cod de bare JDE',
    barcodeROQ: 'Cod de bare ROQ',
    barcodeROQTrim: 'Cod de bare ROQ trim',
    class: 'Clasă',
    department: 'Departament',
    dimensionSystem: 'Clasă personalizată',
    ean: 'EAN',
    eanIdPadre: 'EAN părinte',
    itemId: 'ID articol',
    stagioneROQ: 'Sezon ROQ',
    subclass: 'Tip model',
    subdepartment: 'Subdepartament',
    variantType: 'Tipologie ',
    variantModel: 'Model variantă',
    cardCode: 'Cod card',
    label: 'Etichetă',
    rfidEnabled: 'RFID activat',
    stato: 'Stare',
    ricondizionamentoFornitore: 'Recondiționare furnizor',
    codiceShelf: 'Compartiment de stoc',
    montante: 'Montant',
    ripiano: 'Raft',
    scaffale: 'Stelaj',
    ASSOCIATED: 'Asociat',
    NOT_ASSOCIATED: 'Neasociat',
    REPLACED_ASSOCIATION: 'Înlocuit',
    identifiers: 'Identificatori',
    force_parcel: 'Forțează coletul',
    force_parcel_message: 'Sigur vrei să forțezi acest colet?',
    pesa_collo: 'Cântărire colet',
    peso_kg: 'Greutate (kg)',
    wrong_packaging_code: 'Cod de ambalare greșit',
    packaging_confirmed_no_weight: 'Confirmi un colet fără greutate, vrei să continui?',
    attention: 'Atenție',
    continue: 'Continuă',
    model: 'Model',
    sizeCode: 'Cod mărime',
    sizeDescription: 'Descriere mărime',
    serial: 'Serie',
    identifier: 'Serie',
    product: 'Cod de bare BC',
    shift: 'Tură',
    destination: 'Destinație',
    regDate: 'Data',
    listPosition: 'Poziție în listă',
    list: 'Listă',
    customerName: 'Nume client',
    regTime: 'Ora',
    event: 'Eveniment',
    customer: 'Client',
    isCarryover: 'Carryover',
    carryoverValue: 'Carryover',
    madeIn: 'Fabricat în',
    collectionCode: 'Colecție',
    collectionDescription: 'Descriere colecție',
    collectionYear: 'An',
    fatherProductValue: 'Produs părinte',
    genderValue: 'Gen',
    genderValueDescription: 'Descriere gen',
    line: 'Linie de brand',
    lineDescription: 'Descriere linie',
    marchioDescription: 'Descriere marcă',
    marchioValue: 'Marcă',
    merchandiseClassCode: 'Categorie',
    merchandiseClassDescription: 'Descriere categorie',
    merchandiseSubclassCode: 'Subcategorie',
    merchandiseSubclassDescription: 'Descriere subcategorie',
    modelPartColor: 'Culoare parte model',
    modelPartColorSizeValue: 'Mărime culoare parte model',
    isPermanent: 'Permanent',
    permanentValue: 'Permanent',
    isSeasonal: 'Sezonier',
    seasonalValue: 'Sezonier',
    sleeveTypeValue: 'Tip mânecă',
    origin_location_mandatory_field_error: 'Locația de origine este obligatorie',
    transactionDate_mandatory_field_error: 'Data tranzacției este obligatorie',
    customerCode_mandatory_field_error: 'Codul clientului este obligatoriu',
    tipology_field_error: 'Tipologia este obligatorie',
    warehouseUsa_relabeling_mandatory_fields_error: 'Reetichetarea este obligatorie',
    //valentino
    sconosciuto: 'NECUNOSCUT',
    prodottoSconosciuto: 'Produs necunoscut',
    reads_ok: 'CITIRI OK',
    tot_to_check: 'Total de verificat',
    //moncler
    confirm_force_received_text: 'Această expediere a fost deja confirmată. Vrei să o elimini din listă?',
    confirm_force_received_sap_text: 'Expedierea a fost deja recepționată în SAP. Vrei să o elimini din listă?',
    confirm_force_received_partially_sap_text:
      'Expedierea a fost recepționată PARȚIAL. Finalizeaz-o în SAP. Vrei să o elimini din listă?',
    //louis vuitton
    tooManyTags: 'Prea multe taguri',
    nfcDetectedPleaseUseProductControl: 'Tag NFC detectat. Folosește funcționalitatea Control produs.',
    GENERIC_ERROR: 'Eroare generică - Contactează suportul prin ContactIS',
    ECERTIFICATE_WORKORDER_NOT_FOUND: 'Comanda de lucru nu a fost găsită în eCertificate',
    ITEM_IN_ANOTHER_PARCEL: 'Acest articol este deja declarat într-un alt colet',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED:
      'Comanda de lucru este creată în eCertificate, dar nu este finalizată',
    INVALID_TIMESTAMP: 'Marcaj temporal invalid',
    INVALID_SERIAL: 'Număr de serie invalid',
    INVALID_WORKORDER: 'Număr de comandă de lucru invalid',
    INVALID_SKU: 'SKU invalid',
    INVALID_PARCEL_NUMBER: 'Număr de colet invalid',
    SAP_UCS_NOT_CONFIRMED: 'UCS *{parcelCode} neconfirmat la sfârșitul liniei de asamblare',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: 'Sincronizarea removabilă nu a fost efectuată',
    SAP_INCORRECT_OPERATION_STATUS: 'Starea operațiunii UCS *{parcelCode} nu este corectă în SAP ME',
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCS deja finalizat în SAP, absent din T&T',
    SAP_UCS_CANNOT_BE_COMPLETED: 'UCS *{parcelCode} nu poate fi finalizat în SAP ME/MII',
    SAP_WORKORDER_CLOSED: 'Comanda de lucru asociată UCS *{parcelCode} este închisă în SAP MII',
    SAP_INTERNAL_ERROR: 'Eroare tehnică în SAP MII',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: 'Timeout -> Agregarea este OK',
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: 'Numărul de colet este deja agregat în LVSP',
    LVSP_SERIAL_ALREADY_AGGREGATED: 'Numărul de serie este deja agregat anterior în LVSP',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'Neconcordanță între cantitatea scanată și cantitatea așteptată în LVSP',
    LVSP_SKU_NOT_FOUND: 'SKU necunoscut în LVSP',
    LVSP_SUPPLIER_NOT_FOUND: 'Furnizor necunoscut în LVSP',
    TECHNICAL_ERROR: 'Problemă tehnică - contactează suportul prin ContactIS',
    ERROR_IN_PARCEL_ITEMS:
      'A apărut o eroare la confirmarea coletului. Golește coletul folosind pictograma coș de gunoi, apoi scanează din nou toate articolele',
    NFC_PRODUCT_NOT_ALLOWED: 'SKU necesită un tag NFC. Folosește funcționalitatea Control produs.',
    product_is_authentic: 'Produsul este autentic',
    not_sellable: 'NU POATE FI VÂNDUT. Deschide un tichet NeoContact (pune în bucket-ul WDF).',
    stock_product:
      'PRODUS DE STOC: Păstrează produsul ca vandabil. RETUR CLIENT: Ok pentru retur sau schimb, păstrează produsul ca vandabil.',
    store_action: 'Acțiune magazin',
    reprint: 'Retipărește',
    reprint_sent: 'Retipărire trimisă',
    row: 'Rând',
    longSKU: 'SKU lung',
    pairingDate: 'Data producției',
    citesFlag: 'Cites',
    pairingSupplier: 'Furnizor',
    batchNumber: 'Lot',
    status: 'Stare',
    chrono: 'Chrono',
    logisticStatus: 'Stare produs',
    serialNumber: 'Număr de serie RFID',
    returnCode: 'Cod de retur',
    viewCitesDocument: 'Vezi documentul CITES',
    LV_LE_ERROR_ON_QUANTITY: 'Cantitatea coletului Limited Edition trebuie să fie 1',
    LV_CUSTOM_DECODE_FAILED: 'Decodarea tagului LV a eșuat',
    // others
    reference: 'Referință',
    sender: 'Expeditor',
    year: 'An',
    number: 'Număr',
    TAG_STATUS_CONFIRMED: 'Deja asociat',
    halfpair: 'Jumătate de pereche'
  },
  imbustatrice: {
    and: ' și ',
    unkwon_tag: 'Tag necunoscut',
    dynamic_tag: 'Tag {{role}}',
    dynamic_tag_missing: 'Tag {{role}} lipsă',
    too_many_dynamic_tags: 'Prea multe taguri {{role}}',
    dynamic_tag_already_associated: 'Tag {{role}} deja asociat',
    wrong_tag: 'Tag greșit',
    missing_tag: 'Tag lipsă'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: 'Deja asociat',
    TAG_ALREADY_ASSOCIATED_TO_WORKORDERROW: 'Tag deja asociat rândului comenzii de lucru',
    WRONG_QC_STATUS: 'Stare greșită a controlului de calitate',
    WRONG_QC_SIZE: 'Mărime greșită la controlul de calitate',
    WRONG_QC_MODEL: 'Model greșit la controlul de calitate',
    MISSING_MANDATORY_QC: 'Control de calitate lipsă',
    MISSING_PRODUCT_INFO: 'Informații despre produs lipsă',
    WRONG_TAG: 'Tag greșit',
    UNKNOWN_TAG: 'Tag necunoscut',
    WRONG_PRODUCT: 'Produs greșit',
    MISSING_MANDATORY_TAG: 'Tag obligatoriu lipsă',
    MISSING_OPTIONAL_TAG: 'Tag opțional lipsă',
    EXTRA_TAG: 'Tag suplimentar',
    TAG_MISMATCH: 'Tag neconcordant',
    PRODUCTIONORDERROW_MISMATCH: 'Asociere neconcordantă a rândului comenzii de producție',
    MISSING_SYSTEM_TAG: 'Tag necunoscut',
    UNEXPECTED_TAG: 'Tag neașteptat',
    NOT_EXISTING_CERTILOGO_TAG: 'Codul Certilogo nu este prezent în sistem',
    KILLED_TAG: 'Tag dezactivat definitiv',
    MISSING_TAG: 'Tag lipsă',
    TOOL_DETECTED: 'Tag de unealtă detectat',
    TAG_NOT_PREENCODED: 'Tag necodificat în prealabil'
  },
  statuses: {
    RESTORE_VARIANT: 'RESTABILEȘTE TIPOLOGIA',
    CONFIRM_ERROR: 'EROARE DE CONFIRMARE'
  },
  userSettings: {
    title: 'Setări utilizator',
    autostopAntennaTimeout: 'Timeout oprire antene (ms)',
    autostartAntenna: 'Pornire automată antenă',
    autoConfirmParcel: 'Confirmare automată colet',
    barcodeItemRead: 'Citire cod de bare articol',
    antennas: 'Setări antene',
    resetReadingsAfterOperation: 'Viteză resetare după confirmare',
    slow: 'Lent',
    medium: 'Mediu',
    fast: 'Rapid',
    printerCode: 'Cod imprimantă',
    enableOkSounds: 'Sunete OK',
    enableKoSounds: 'Sunete KO'
  },
  attributes: {
    material: 'Material',
    workerCode: 'Cod lucrător',
    workerExternalCode: 'Cod extern lucrător',
    workerIdentifier: 'Identificator lucrător',
    workerDescription: 'Descriere lucrător',
    workerType: 'Tip lucrător',
    orderCode: 'Cod comandă',
    sapQualityControlStatus: 'Stare control calitate SAP',
    quantityOkWorker: 'CANT. OK LUCRĂTOR',
    quantityKoWorker: 'CANT. KO LUCRĂTOR',
    quantityOkRepair: 'CANT. OK REPARAȚIE',
    quantityOkValdagno: 'CANT. OK VALDAGNO',
    quantityOkFirstInbound: 'CANT. OK PRIMA INTRARE',
    quantityOkRis: 'CANT. RISC',
    quantityKoValdagno: 'CANT. KO VALDAGNO',
    quantitySecondValdagno: 'CANT. ALEGERE A DOUA',
    quantityOkLining: 'CANT. OK CĂPTUȘEALĂ',
    quantityKoLining: 'CANT. KO CĂPTUȘEALĂ'
  },
  title: {
    report_problem: 'Raportează o problemă',
    delete_shipment_title: 'Confirmare ștergere'
  },
  subtitle: {
    report_problem: 'Descrie problema întâlnită sau sugerează o îmbunătățire',
    delete_shipment_message: 'Sigur vrei să ștergi această expediere?'
  },
  label: {
    name: 'Nume',
    email: 'Email',
    description: 'Descrierea problemei',
    close: 'Închide',
    submit: 'Trimite feedback'
  },
  success: {
    message: 'Îți mulțumim pentru feedback!'
  },
  button: {
    submit: 'Trimite',
    submitting: 'Se trimite...'
  },
  pre_encoding: {
    correct: 'Corect',
    correction_title: 'Corecție superioară',
    association_extra_right: 'Îndepărtează pantoful drept de pe Pad și lasă doar pe cel stâng',
    association_extra_left: 'Îndepărtează pantoful stâng de pe Pad și lasă doar pe cel drept',
    correction_instruction_right: 'Îndepărtează pantoful drept de pe Pad și lasă doar pe cel stâng așezat',
    correction_instruction_left: 'Îndepărtează pantoful stâng de pe Pad și lasă doar pe cel drept așezat',
    epc_reading: 'EPC: se citește....',
    epc_label: 'EPC: {{epc}}',
    write_correction: 'Scrie corecția',
    correction_in_progress: 'Corecție în curs...',
    correction_write_success: 'Corecție finalizată cu succes',
    correction_read_error: 'Citește un singur tag pe Pad'
  }
}
